import React, { useState, useContext } from "react";
import { PencilAltIcon, ViewGridIcon } from "@heroicons/react/solid";
import Context from "../context/context";
import { openDB } from "idb";
import { v4 as uuid } from "uuid";

const DraggableList = ({
  title,
  draggable,
  setIsSeatModified,
  item,
  selectedValue,
  setSelectedValue,
  setIsSectionOpen
}) => {
  const [isNewOpen, setIsNewOpen] = useState(false);

  const context = useContext(Context);
  const { setUnAuthPopup } = context;
  let restrictions = JSON?.parse(sessionStorage?.getItem("restrictions")) || [];
  const noWarning = () => {
    setUnAuthPopup(true);
    setTimeout(() => setUnAuthPopup(false), 3000);
  };
  const handleEdit = async (da) => {
    const db = await openDB("FoodDo", +localStorage?.getItem("IDBVersion") || 1);
    let objectStore = await db?.transaction("outlet", "readwrite")?.objectStore("outlet");
    let outlet_uuid = localStorage?.getItem("outlet_uuid");
    let obx = await objectStore?.get(outlet_uuid);
    let x = await obx?.section_details?.filter((sec) => sec?.section_name === da);
    setSelectedValue({
      section_sort_order: x[0]?.section_sort_order,
      section_uuid: x[0]?.section_uuid,
      UUID: x[0]?.UUID,
      section_name: x[0]?.section_name,
    });
    setIsSectionOpen({ status: true, type: 'edit' })
    setIsSeatModified(uuid());
  };

  return (
    <>
      <div className='nav_link_container'>
        <div
          draggable={draggable}
          className={`nav-link ${title === "All" ? "" : ""}`}>
          <p
            style={{
              justifyContent: `${draggable ? "flex-start" : "center"}`,
            }}>
            {draggable && (
              <ViewGridIcon
                style={{
                  minWidth: "1rem",
                  maxWidth: "1rem",
                  marginRight: 10,
                  cursor: "move",
                }}
              />
            )}
            <span className='nav_title'>{title}</span>
            {window.location.pathname.includes("page5") ? (
              <button onClick={
                +restrictions[0]?.other_menu_and_seat_new_edit_seat_section === 0
                  ? () => noWarning()
                  : (e) => {
                    e.stopPropagation()
                    console.log("clicked")
                    setIsNewOpen(!isNewOpen);
                    handleEdit(item?.section_name);
                  }
              } style={{ width: "35px", cursor: "pointer", background: "transparent", border: "none" }}
              ><PencilAltIcon /></button>
            ) : (
              ""
            )}
          </p>
        </div>
      </div>
      <br />
    </>
  );
};
export default DraggableList;
